const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  role: state => state.user.userInfo.role || '' // Default to supplier for testing if not set
}
export default getters
